import type { TermsOfTransition } from 'types/course/termsOfTransition';
import { useTermsOfTransition } from 'shared/composables/useTermsOfTransition';

/**
 * Synthetic rule applied to a filter step that had nothing to correct.
 * A skipped filter never produces a score, so evaluating the CMS rules
 * against its default `0` would land in whatever the author mapped the
 * low band to (typically `Redo_Current`) and trap the learner on an empty
 * step. Skipping is always a pass — the learner already proved the skill.
 */
export const SKIPPED_FILTER_TRANSITION: TermsOfTransition = {
  id: -1,
  label: 'skipped_filter',
  from: 0,
  to: 100,
  action: 'Go_To_Next',
  result_feedback: '',
};

export function resolveStepTransition({
  termsOfTransition,
  score,
  isSkippedFilter,
}: {
  termsOfTransition: TermsOfTransition[];
  score: number;
  isSkippedFilter: boolean;
}): TermsOfTransition | null | undefined {
  if (isSkippedFilter) return SKIPPED_FILTER_TRANSITION;
  return useTermsOfTransition(termsOfTransition).getTermsOfTransition(score);
}
